import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listAudit, listDLQ, resolveConflict, type AuditFilters, type DLQFilters } from '@/api/admin';

export function useDLQ(filters: DLQFilters) {
  return useQuery({
    queryKey: ['admin', 'dlq', filters],
    queryFn: () => listDLQ(filters),
    staleTime: 10_000,
  });
}

export function useAudit(filters: AuditFilters) {
  return useQuery({
    queryKey: ['admin', 'audit', filters],
    queryFn: () => listAudit(filters),
    staleTime: 10_000,
  });
}

export function useResolveConflict(phone: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      action: 'MERGE' | 'KEEP_SEPARATE';
      reason: string;
      primaryPhone?: string;
      involvedPhones?: string[];
    }) => resolveConflict(phone, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['entrepreneurs', 'get', phone] });
      void qc.invalidateQueries({ queryKey: ['entrepreneurs', 'timeline', phone] });
      void qc.invalidateQueries({ queryKey: ['entrepreneurs', 'search'] });
    },
  });
}
